import script from "./UserinfoEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./UserinfoEdit.vue?vue&type=script&setup=true&lang=js"

import "./UserinfoEdit.vue?vue&type=style&index=0&id=ff102da8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff102da8"]])

export default __exports__